export default function createImageAvatarStyle({ avatarSize }) {
  return {
    height: avatarSize,
    overflow: 'hidden',
    width: avatarSize
  };
}
